import apiCall from "../apiService";
import { AUTH_ROUTES } from "../../utils/constants/apiRoute";
/**
 * Adds a new product using the centralized API call utility.
 *
 * @param {Object} product
 * @param {string} product.prodName
 * @param {string|number} product.prodPrice
 * @param {string} product.prodCategoryId
 * @param {string} product.prodCategoryName
 * @param {string|number} product.quantity
 * @returns {Promise<Object>}
 *
 * @author Susovan Mishra
 */
const createProducts = async (product) => {
  const formData = new FormData();
  formData.append("prodName", product.prodName);
  formData.append("prodPrice", Number(product.prodPrice));
  formData.append("prodCategoryId", product.prodCategoryId);
  formData.append("prodCategoryName", product.prodCategoryName);
  formData.append("quantity", Number(product.quantity));
  formData.append("description", product.description || "");
  formData.append("imageUrl", product.imageUrl || "");
  formData.append("veg", Boolean(product.veg));
  if (product.file) {
    formData.append("file", product.file);
  }
  return await apiCall(AUTH_ROUTES.PRODUCTS_API_ENDPOINT, {
    method: "POST",
    body: formData,
  });
};

export default createProducts;